import ProdSurplusHeader from "./Header";
import "./index.css";
import ProdSurplusTreatment from "./SurplusResource";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const ProdSurplusResources = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });

  return (
    <div className="prod-surplus-resources-container" id="prod-surplus-id">
      <ProdSurplusHeader productId={productId} show={show} />
      <ShowHide show={show} setShow={setShow} />
      {show && <ProdSurplusTreatment productId={productId} />}
    </div>
  );
};

export default ProdSurplusResources;
